export default __webpack_public_path__ + "static/media/gapstack-white.e9154399.svg";